import { apiDeckGetters } from '@/store/modules/apiDeck/routines'

export default {
  [apiDeckGetters.APIDECK_INTEGRATION]: state => state.apiDeckIntegration,
  [apiDeckGetters.ROUTE_NAME_AFTER_INTEGRATION]: state => state.routeNameAfterIntegration,
  [apiDeckGetters.APIDECK_ERROR]: state => state.apiDeckError,
  [apiDeckGetters.IS_EXTERNAL_APIDECK_INTEGRATION_COMPLETE]: state => state.isExternalApiDeckIntegrationComplete
}
